export const GET_ALL_CUSTOM_ATTRIBUTES_REQUESTED = 'GET_ALL_CUSTOM_ATTRIBUTES_REQUESTED';
export const GET_ALL_CUSTOM_ATTRIBUTES_SUCCEEDED = 'GET_ALL_CUSTOM_ATTRIBUTES_SUCCEEDED';
